/*Bibliotecas */
/*Estilos */
import { Contenedor } from './Loading.styles';

const Loading = (props: any) => {
    return (
        <Contenedor {...props}>
            <div className="pcom-loading">
                <svg className="pcom-spinner" viewBox="0 0 66 66" xmlns="https://www.w3.org/2000/svg">
                    <circle className="pcom-circle" fill="none" strokeLinecap="round" cx="33" cy="33" r="30"></circle>
                </svg>
                {props.title && <span className="loadingTittle">{props.title}</span>}
            </div>
        </Contenedor>
    );
};

export default Loading;
